/** Feature switches for Rush Hour. Flip one to change it everywhere (game, settings, boards, server).
 *
 * SHIELDS_ENABLED: false = a pure roguelike, one life: the first obstacle you hit ends the run (owner decision,
 * 20 Oct 2026). true = the player can choose One hit / 3 shields / 3 shields with rings healing in Settings, boards
 * show a shield-mode filter, and the server accepts all three modes. The lab switch ?shields turns them on for one
 * session for testing; such runs are never ranked. */
export const SHIELDS_ENABLED = false;

/** Shields for this session: the switch, or the ?shields lab flag (remembered for the tab). */
export function shieldsOn(): boolean {
  if (SHIELDS_ENABLED) return true;
  try { return sessionStorage.getItem('spermtan.shields') === '1'; } catch { return false; }
}
